import './Home.css';
import './HomeNav.css'; // <-- Import the new CSS file
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import ParticlesBackground from './ParticlesBackground';
import { Typewriter } from 'react-simple-typewriter';

function Home() {
    function TypewriterText() {
        return (
            <h1>
                I'm a &nbsp;
                <span className='typewriter'>
                    <Typewriter 
                        words={['backend engineer', 'systems programmer', 'ML researcher', 'CS student @ Georgia Tech']}
                        loop={true}
                        cursor
                        cursorStyle="|"
                        typeSpeed={150}
                        deleteSpeed={100}
                        delaySpeed={2000}
                    />
                </span>
            </h1>
        )
    }
    return (
        // FIX: Added a container div for proper positioning context
        <div className="home-container">
            <nav className="home-nav">
                <ul>
                    <li><a href="#about">About</a></li>
                    <li><a href="#experience">Experience</a></li>
                    <li><a href="#projects">Projects</a></li>
                    <li><a href="#skills">Skills</a></li>
                    <li><a href="#contact">Contact</a></li>
                </ul>
            </nav>
            <ParticlesBackground />
            <section id="home" className="home">
                <h3>Hi, I'm Yash Panchal</h3>
                <TypewriterText />
                <div className="home-links">
                    <div className="social-icons">
                        <a href="https://github.com/yashcpanchal/" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
                        <a href="https://www.linkedin.com/in/yashcpanchal/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
                    </div>
                    <a href="/Yash_Panchal_Resume.pdf" download="Yash_Panchal_Resume.pdf" className="resume-btn">View Resumé</a>
                </div>
            </section>
        </div>
    );
}

export default Home;
